/** Raw ERP resources from GET_ERP_RESOURCES (untransformed API rows). */
export const getMachineERPResources = (state) => {
  return state?.machineERPResources || [];
};
